'use strict'
import moment from 'moment'

function processFieldErrors (saveResponse) {
  let errors = {}
  if (saveResponse && saveResponse.fieldErrors !== null && saveResponse.fieldErrors !== undefined) {
    for (let error of saveResponse.fieldErrors) {
      // if fieldname includes an array index, split out the index number and tag it onto the end of the fieldname
      if (error.fieldName.indexOf('[') >= 0) {
        let startIndex = error.fieldName.indexOf('[')
        let endIndex = error.fieldName.indexOf(']')
        let index = error.fieldName.substring(startIndex + 1, endIndex)
        let field = error.fieldName.substring(endIndex + 2)
        errors[field + index] = error.errorMessage
      } else {
        errors[error.fieldName] = error.errorMessage
      }
    }
  }
  return errors
}

function processSuccessMessage (saveResponse) {
  if (saveResponse.result === 'success') {
    return true
  } else {
    return false
  }
}

function processErrorMessage (saveResponse) {
  let errors = []
  if (saveResponse && saveResponse.globalErrors !== null) {
    for (let error of saveResponse.globalErrors) {
      errors.push(error)
    }
  }
  return errors
}

/**
 * Returns map of request parameters
 * @param query - window query string
 * @returns {*}
 */
function getRequestParameters (query) {
  if (!query) {
    return { }
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((params, param) => {
      let [ key, value ] = param.split('=')
      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''
      return params
    }, { })
}

// Return academic year from given string ('MM/DD/YYY') formatted date
function getAcademicYear(dateString) {
  const parsedDate = new Date(dateString);
  const year = parsedDate.getFullYear();

  // Define the special cutoff date for 2024
  const cutoffDate2024 = new Date('2024-08-16');

  // Define the start and end dates for the academic year range
  const startDate = new Date(year, 7, 1); // August 1 of the current year
  const endDate = new Date(year + 1, 0, 1); // January 1 of the next year

  // Special case for the cutoff in 2024
  if (year === 2024 && parsedDate >= cutoffDate2024) {
    return 2025;
  }

  // General rule for dates between August 1 and January 1 of the next year
  if (parsedDate >= startDate && parsedDate < endDate) {
    return year + 1;
  }

  // Default to current year if outside the academic year range
  return year;
}

function getAcademicYearFromInt (year) {
  if (year) {
    let yearStr = (year - 1) + '-' + year.toString().substring(2)
    return yearStr
  }

  return ''
}

function convertDateToString (date) {
  if (date && typeof date !== 'string' && !(date instanceof String)) {
    return date.format('MM/DD/YYYY')
  } else {
    return date
  }
}

function validateNumberPress (e, allowDecimal) {
  let keyCodeArray = [46, 8, 9, 27, 13, 110]
  if (allowDecimal) keyCodeArray.push(190)
  // Allow: backspace, delete, tab, escape, enter and .
  if (keyCodeArray.indexOf(e.keyCode) !== -1 ||
    // Allow: Ctrl/cmd+A
    (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
    // Allow: Ctrl/cmd+C
    (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
    // Allow: Ctrl/cmd+X
    (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
    // Allow: home, end, left, right
    (e.keyCode >= 35 && e.keyCode <= 39)) {
    // let it happen, don't do anything
    return
  }
  // Ensure that it is a number and stop the keypress
  if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
    e.preventDefault()
  }
}

export default {
  processFieldErrors: processFieldErrors,
  processSuccessMessage: processSuccessMessage,
  processErrorMessage: processErrorMessage,
  getRequestParameters: getRequestParameters,
  getAcademicYear: getAcademicYear,
  getAcademicYearFromInt: getAcademicYearFromInt,
  convertDateToString: convertDateToString,
  validateNumberPress: validateNumberPress
}



// WEBPACK FOOTER //
// ./src/js/common/VueFormHelper.js